import React from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { Skeleton } from "antd";
import { CardTimeline } from "./TimelineComp/component";

const TimelineSkeleton = (props) => {
	return (
		<CardTimeline large={props.large} tw="p-6!">
			<span tw="absolute top-2 left-2 rounded-full">
				<Skeleton.Avatar active size={"default"} shape={"circle"} />
			</span>

			<div tw="absolute top-2 right-2">
				{" "}
				<Skeleton.Button active size={"default"} shape={"round"} />
			</div>

			<span
				tw="absolute bottom-4 left-2 rounded-md px-3 py-3 inline-flex flex-nowrap items-center space-x-3"
				className="midFadedBg">
				<span tw="inline-flex flex-nowrap items-center">
					<Skeleton.Button active size={"small"} shape={"square"} />
				</span>

				<span tw="inline-flex flex-nowrap items-center">
					<Skeleton.Button active size={"small"} shape={"square"} />
				</span>

				<span tw="inline-flex flex-nowrap items-center">
					<Skeleton.Button active size={"small"} shape={"square"} />
				</span>
			</span>

			<span tw="absolute bottom-6 right-2">
				<Skeleton.Button active size={"default"} shape={"round"} />
			</span>
		</CardTimeline>
	);
};

export default TimelineSkeleton;
